export default "__VITE_ASSET__C57fGeWw__"